import { TypeCampaignEnum } from '@/types';
import type { FlowOperatorMetadata } from '@/types/flow-types';
import { canDeleteTrigger } from '@/components/flows/operators/registry';

export interface SubscribeNewsletterData {
  event: string;
}

export function createDefaultData(): SubscribeNewsletterData {
  return {
    event: 'subscribe_newsletter',
  };
}

const SubscribeNewsletter: FlowOperatorMetadata<SubscribeNewsletterData> = {
  id: 'boxsubscribetonewsletter',
  kind: 'trigger',
  label: 'flows.operators.subscribeNewsletter.label',
  icon: 'fa-envelope-open',
  hasConfiguration: false,
  availableIn: [],
  hidden: true,

  incompatibilities: {
    [TypeCampaignEnum.AUTOMATION]: {
      nextOperators: [
        'boxabandonpanier', 'boxperiodiclaunching', 'boxscrollpage',
        'boxstatuscommand', 'boxregisteronsite', 'boxsubscribetonewsletter',
        'boxtag', 'boxlist', 'openemail',
        'clicklink', 'boxtriggerinternalevent',
      ],
    },
  },

  defaultData: createDefaultData,

  outputs: () => 1,

  canBeDeleted(operatorId: string, flow: any): Promise<boolean | string> {
    return canDeleteTrigger(flow, operatorId);
  },
};

export default SubscribeNewsletter;
